<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img37.jpg"/></p>
<p class="chap"><a id="ch17"></a>VIRGINIA COMPANY’S DEMISE, 1624</p>
<p class="noindent"><span class="big">A</span>fter nearly two decades of heroic effort, in 1624 the Virginia Company finally surrendered. It was brushed aside by a royal government hungry for tobacco profits. Thousands of settlers the company had sent to Virginia had died of disease, starvation, or conflict with Native Americans. Not until mid-century did the annual death rate drop below 25 percent and natural growth take over. By 1616, it had spent over £50,000, a huge sum for those days, equivalent to about $11 million in today’s currency. And then in 1622, Opechancanough, the Algonquian chief, attacked the colony.</p>
<p class="indent">When word reached England that the Native Americans had killed a third of the colony’s European population, the royal government threw in the towel. Frustrated by the company’s failures and hungry for increased tobacco revenues, the crown terminated the company charter and made Virginia the first royal colony of England’s new empire. <span class="color">(12-018)</span></p>
<p class="image"><img alt="image" src="images/img38.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter017.vue?95404090